import React, { useCallback } from 'react';
import { FormLabel, FormControl, ListItem, ListItemText, FormHelperText } from '@material-ui/core';
import { MeetingList, MeetingItem } from 'components/meetings-list';
import style from './index.module.scss';
import { dateFormat } from 'utils/dates';
import { useTranslate } from 'hooks/use-translate';

interface Props {
  error?: boolean;
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  value: string;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  options: MeetingItem[];
}
export const AppInputMeetingListSelect: React.FC<Props> = ({
  error,
  label,
  helperText,
  value,
  onChange,
  disabled,
  options,
}) => {
  const { tp } = useTranslate();

  const handleChangeMeetingToday = useCallback(() => {
    onChange('today');
  }, [onChange]);

  const handleChangeMeeting = useCallback(
    (v: string | null) => {
      onChange(v);
    },
    [onChange],
  );

  return (
    <FormControl className={style.root} error={error} fullWidth component="fieldset">
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <div>
        <ListItem
          button
          onClick={handleChangeMeetingToday}
          className={style.meeting}
          disabled={disabled}
          selected={value === 'today'}
        >
          <ListItemText
            secondary={tp('today')}
            secondaryTypographyProps={{
              color: 'textSecondary',
            }}
            primary={dateFormat(new Date())}
            primaryTypographyProps={{
              style: {
                fontWeight: 'bold',
              },
            }}
          />
        </ListItem>
        <MeetingList
          value={value}
          className={style.meetings}
          multiple={false}
          options={options}
          disabled={!!disabled}
          onChange={handleChangeMeeting}
        />
      </div>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
